"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCart = exports.uploadImageByUrl = exports.uploadImage = exports.getCustomerOrderStats = exports.getStats = exports.getBanners = exports.getCategories = exports.getCategory = exports.getCatAttributes = exports.getOrderStats = exports.getOrderHistory = exports.updateProductLibrary = exports.deleteProductLibrary = exports.getProductLibraryCollection = exports.addProductLibrary = exports.getProductLibrary = exports.addToCart = exports.getAllProduct = exports.calc = exports.getAllProductsInCategory = exports.deleteArtworkLibrary = exports.deleteArtworkLibraryCollection = exports.createArtworkLibraryCollection = exports.updateArtworkLibrary = exports.createArtworkLibrary = exports.getArtworkLibraryCollection = exports.findArtworkLibrary = exports.getArtworkLibrary = void 0;
var axios_1 = __importDefault(require("axios"));
axios_1.default.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// Artwork Library
exports.getArtworkLibrary = function (filter) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.get("/sfapi/customer-artwork-library?$sort[" + ((filter === null || filter === void 0 ? void 0 : filter.sortBy) || "createdAt") + "]=" + ((filter === null || filter === void 0 ? void 0 : filter.sortBy) !== "createdAt" ? 1 : -1) + "}", {
                params: {
                    $populate: ["artwork", "collections"],
                    "collections[$in]": (filter === null || filter === void 0 ? void 0 : filter.collections) || undefined,
                    "artworkFilename[$LIKE]": (filter === null || filter === void 0 ? void 0 : filter.artwork) || undefined,
                    $skip: (filter === null || filter === void 0 ? void 0 : filter.skip) || 0
                }
            })];
    });
}); };
exports.findArtworkLibrary = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.get("/sfapi/customer-artwork-library/" + id, {
                params: {
                    $populate: ["artwork", "collections"]
                }
            })];
    });
}); };
exports.getArtworkLibraryCollection = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.get("/sfapi/customer-artwork-library-collections?$np=1", {
                params: {
                    "$sort[name]": 1
                    // $np: 1
                }
            })];
    });
}); };
exports.createArtworkLibrary = function (uploadLog, collections) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.post("/sfapi/customer-artwork-library", {
                artwork: uploadLog,
                collections: collections
            })];
    });
}); };
exports.updateArtworkLibrary = function (artwork, collections) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.patch("/sfapi/customer-artwork-library/" + artwork._id, __assign(__assign({}, artwork), { collections: collections }))];
    });
}); };
exports.createArtworkLibraryCollection = function (name) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.post("/sfapi/customer-artwork-library-collections", {
                name: name
            })];
    });
}); };
exports.deleteArtworkLibraryCollection = function (id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, axios_1.default.delete("/sfapi/customer-artwork-library-collections/" + id)];
}); }); };
exports.deleteArtworkLibrary = function (id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, axios_1.default.delete("/sfapi/customer-artwork-library/" + id)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
exports.getAllProductsInCategory = function (category) {
    return axios_1.default.get("/sfapi/products", {
        params: {
            category: category,
            $populate: ["attributes.value"],
            $select: ["key", "attributes", "staticName", "_id", "price"],
            $np: "1"
        }
    });
};
// Product
exports.calc = function (values) {
    return axios_1.default.post("/sfapi/products-legacy/calculator/v3", {
        category: values === null || values === void 0 ? void 0 : values.category,
        selectedAttributes: __assign({}, (values.selectedAttributes || {}))
    });
};
exports.getAllProduct = function (id) {
    return axios_1.default.get("/sfapi/products/" + id, {
        params: {}
    });
};
exports.addToCart = function (values) {
    var _a, _b, _c, _d;
    console.log("values", values);
    return axios_1.default.post("/sfapi/cart/add-item", {
        product: values.product,
        value: (values === null || values === void 0 ? void 0 : values.quantity) || 1,
        artworkSlotsWithUrls: __spreadArrays((values.artworkSlotsWithUrls || [])),
        images: __spreadArrays((values.images || [])),
        // designTemplate: values.designTemplate,
        customFields: (_b = (_a = values.designTemplateFields) === null || _a === void 0 ? void 0 : _a.filter(function (field) { return field.key; })) === null || _b === void 0 ? void 0 : _b.map(function (field) { return ({
            type: "text",
            key: field.key,
            label: field.key,
            value: field.value
        }); }),
        // designTemplateFields: values.designTemplateFields,
        metadata: __spreadArrays([
            { key: "coa", value: values.designTemplate }
        ], (((_d = (_c = values.designTemplateFields) === null || _c === void 0 ? void 0 : _c.filter(function (field) { return field.key; })) === null || _d === void 0 ? void 0 : _d.map(function (field) { return ({
            type: "text",
            key: field.key,
            label: field.key,
            value: field.value
        }); })) || []))
    });
};
// Product Library
exports.getProductLibrary = function (filter) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.get("/sfapi/customer-product-library?$sort[" + ((filter === null || filter === void 0 ? void 0 : filter.sortBy) || "createdAt") + "]=" + ((filter === null || filter === void 0 ? void 0 : filter.sortBy) !== "createdAt" ? 1 : -1) + ((filter === null || filter === void 0 ? void 0 : filter.filterBy) ? "&" + (filter === null || filter === void 0 ? void 0 : filter.filterBy) : ""), {
                params: {
                    $populate: [
                        "artwork",
                        // "customerArtwork.artwork",
                        "productAttributes.value",
                        "product",
                        "category"
                        // "attributes.value",
                    ],
                    $np: 1,
                    // "collections[$in]": filter?.collections || undefined,
                    "category[$in]": (filter === null || filter === void 0 ? void 0 : filter.categories) || undefined,
                    "name[$LIKE]": (filter === null || filter === void 0 ? void 0 : filter.name) || undefined
                    // attributes: filter?.filterBy
                }
            })];
    });
}); };
exports.addProductLibrary = function (_a) {
    var product = _a.product, _b = _a.artwork, artwork = _b === void 0 ? undefined : _b, name = _a.name, _c = _a.customerSku, customerSku = _c === void 0 ? undefined : _c, _d = _a.thumbnail, thumbnail = _d === void 0 ? {} : _d, _e = _a.designTemplateFields, designTemplateFields = _e === void 0 ? [] : _e;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_f) {
            return [2 /*return*/, axios_1.default.post("/sfapi/customer-product-library", {
                    product: product,
                    artwork: artwork,
                    customerSku: customerSku,
                    name: name,
                    thumbnail: thumbnail,
                    designTemplateFields: designTemplateFields
                })];
        });
    });
};
exports.getProductLibraryCollection = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, axios_1.default.get("/sfapi/customer-product-library-collections?$sort[name]=1")];
}); }); };
exports.deleteProductLibrary = function (id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, axios_1.default.delete("/sfapi/customer-product-library/" + id)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
exports.updateProductLibrary = function (product) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.patch("/sfapi/customer-product-library/" + product._id, __assign({}, product))];
    });
}); };
// Order History
exports.getOrderHistory = function (filter) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.get("/sfapi/order-details", {
                params: __assign(__assign({ 
                    // $populate: ["invoice", "customer", "order"],
                    $sort: { createdAt: -1 }, $populateOrderItems: 1 }, filter), { status: undefined, "metadata.value": filter.status })
            })];
    });
}); };
exports.getOrderStats = function (filter) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.post("/sfapi/orders/stats", {
                params: {}
            })];
    });
}); };
// Category Attributes
exports.getCatAttributes = function (catId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.post("/sfapi/products-legacy/category-attributes", {
                category: catId
            })];
    });
}); };
exports.getCategory = function (catId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, axios_1.default.get("/sfapi/products-legacy/category/" + catId)];
}); }); };
exports.getCategories = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.get("/sfapi/categories", {
                params: {
                    hrCode: [
                        "premium-frames",
                        "classic-frames",
                        "classic-canvas",
                        "premium-canvas",
                        "rolled-prints"
                    ]
                }
            })];
    });
}); };
// Banners
exports.getBanners = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, axios_1.default.get("/sfapi/get-banners")];
}); }); };
// Stats
exports.getStats = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, axios_1.default.get("/sfapi/order-item-stats")];
}); }); };
exports.getCustomerOrderStats = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, axios_1.default.post("/sfapi/customer-order-stats")];
}); }); };
// upload misc
exports.uploadImage = function (value) {
    var formData = new FormData();
    formData.append("file", value, "download.jpg");
    return axios_1.default.post("/sfapi/customer-artwork-library/upload", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};
exports.uploadImageByUrl = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios_1.default.post("/sfapi/customer-artwork-library/url-upload", {
                url: url
            })];
    });
}); };
exports.getCart = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, axios_1.default.get("/sfapi/cart", {})];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
